function renderStickyForm() {
  let y_axis_add_to_cart;
  let fake_add_to_cart_btn = $(".fake-add-to-cart-button");
  let variant_should_be_visible = false;
  let form = $("#dtc-form");
  let variant_wrapper = $(".variant-wrapper");
  let element_to_add_margin = $(".product-single__title");
  let add_to_cart_button = $(".add-to-cart");
  let top_window = 0;
  let show_sticky_bar = false;
  let close_variant = $(".close-variant-sticky-form");
  let height_of_form = form.height();
  let hasVariants = true;
  isMobile = isMobile();

  let div = document.querySelector('#fake-add-to-cart-variant-count'); // GETTING THE NUMBERS OF VARIANT
  let textContent = div.textContent;
  let number = parseInt(textContent, 10);

  if (number <= 1) {
    hasVariants = false;
    $("html #dtc-form form").css("width", '100%');
  }

  y_axis_add_to_cart = $(".add-to-cart").offset().top || $(".dtc-cross-selling__trigger").offset().top;
  
  y_axis_add_to_cart = y_axis_add_to_cart - 70;
  
  if (isMobile) {
    if (document.body.classList.contains('sticky-cart-activation'))
    {
      let showVariantOptionson = false;
      show_sticky_bar = (y_axis_add_to_cart < $(window).scrollTop()) ? true : false;
      if (!show_sticky_bar && document.body.classList.contains('sticky-cart-activation') && ($(window).scrollTop()+ window.innerHeight < y_axis_add_to_cart)){
          show_sticky_bar = true;
          showVariantOptionson=true;
      }
      if(show_sticky_bar)
      {
        showStickyBar(showVariantOptionson);
      }
      else
      {
        hideStickyBar();
      }
       if (form.hasClass("dtc-sitcky-form") & hasVariants == true) {
          showFakeButton();
        } else {
          showOriginalButton();
        }
    }
    $(window).on("scroll", () => {
      top_window = $(window).scrollTop();
      let showVariantOptions = false;
      show_sticky_bar = (y_axis_add_to_cart < top_window) ? true : false;
      if (!show_sticky_bar && document.body.classList.contains('sticky-cart-activation') && (top_window+ window.innerHeight < y_axis_add_to_cart)){
          show_sticky_bar = true;
          showVariantOptions = true;
      }
      if(!form.hasClass('show-btn')){
        if(show_sticky_bar)
        {
          showStickyBar(showVariantOptions);
        }
        else
        {
          hideStickyBar();
        }
  
        if (form.hasClass("dtc-sitcky-form") & hasVariants == true) {
          showFakeButton();
        } else {
          showOriginalButton();
        }
      }
    });
  }

  close_variant.click(function () {
    if(form.hasClass("active")){
      closeVariantWindow()
    }else{
      closeVariantWindow(true);
    }
    window.scrollBy({ top: 1, behavior: 'auto' });
  });

  add_to_cart_button.click(function () {
    // hideStickyBar();
     if (form.hasClass("dtc-sitcky-form")){
       hideVarientWrapper();
       form.removeClass("dtc-sitcky-form");
        form.hide();
       $(".sticky-atc-overlay").hide();
       variant_should_be_visible = false;
       enableScrolling();
     }
    // removeMarginToElement();
    
    // fake_add_to_cart_btn.show();
    
    // hideVarientWrapper();
    

    // if (form.hasClass("dtc-sitcky-form")) {
    //   fake_add_to_cart_btn.show();
    //   add_to_cart_button.hide();
    // } else {
    //   fake_add_to_cart_btn.hide();
    //   add_to_cart_button.show();
    // }
    fake_add_to_cart_btn.hide();
      // add_to_cart_button.show();
    // $(window).scrollTop($(window).scrollTop() + 1);
  });

  fake_add_to_cart_btn.click(function () {
    form.addClass("active");
    variant_should_be_visible = true;
    if (show_sticky_bar === true && variant_should_be_visible === true) {
      $(this).hide();
      add_to_cart_button.show();
      $(".sticky-atc-overlay").show();
      showVariantWrapper();
      disableScrolling();
    }
  });

  function isMobile() {
    return (screen_size_mobile = $(window).width() < 500);
  }

  function showStickyBar(showVariantOptions =  false) {
    form.addClass("dtc-sitcky-form");
    
    if (hasVariants == false){
      form.addClass("single-variant");
    }
    addMarginToElement();
    if(!showVariantOptions){
      form.addClass("active");
      $(".product-single__meta .dtc-form-padding").css("padding-bottom", height_of_form+"px");
      hideVarientWrapper();
    }else{
      form.removeClass("active");
      showVariantWrapper()
    }
    fake_add_to_cart_btn.show();
    add_to_cart_button.hide();
    closeVariantWindow(showVariantOptions);
  }

  function hideStickyBar() {
    form.removeClass("active");
    $(".product-single__meta .dtc-form-padding").css("padding-bottom", "");
    form.removeClass("dtc-sitcky-form");
    removeMarginToElement();
    showVariantWrapper();
    add_to_cart_button.show();
  }

  function addMarginToElement() {
    element_to_add_margin.css("margin-top", 0);
  }
  function removeMarginToElement() {
    element_to_add_margin.css("margin-top", 0);
  }

  function hideVarientWrapper() {
    if (isMobile) {
      variant_wrapper.hide();
      $("#dtc-form").removeClass("show-btn");
    }
  }

  function showVariantWrapper() {
    variant_wrapper.show();
  }

  function disableScrolling() {
    $("body").addClass("stop-scrolling");
    close_variant.css("display", "flex");
  }

  function enableScrolling() {
    $("body").removeClass("stop-scrolling");
    close_variant.hide();
  }
  function showFakeButton() {
    fake_add_to_cart_btn.show();
    add_to_cart_button.hide();
  }

  function showOriginalButton() {
    fake_add_to_cart_btn.hide();
    add_to_cart_button.show();
  }

  window.closeVariantWindowWithButton = function closeVariantWindowWithButton() {
    $(".sticky-atc-overlay").hide();
    add_to_cart_button.hide();
    variant_should_be_visible = false;
    hideVarientWrapper();
    enableScrolling();
  };

  function closeVariantWindow(showVariantOptions = false) {
    $(".sticky-atc-overlay").hide();
    fake_add_to_cart_btn.show();
    add_to_cart_button.hide();
    variant_should_be_visible = false;
    // hideVarientWrapper();
    if(!showVariantOptions){
      hideVarientWrapper();
    }else{
      showVariantWrapper();
    }
    enableScrolling();
    form.removeClass("active");
  }
}

document.addEventListener('DOMContentLoaded', () => {
  renderStickyForm();
});

document.addEventListener('swatch:updated', () => {
  renderStickyForm();
});